import { TypographyVariant } from "../../types"

import * as Styled from "./ColoredBadge.styled"

type ColoredBadgeProps = {
    backgroundColor: string,
    className?: string,
    id?: string,
    text: string | number,
    textColor?: string,
    textVariant?: TypographyVariant,
}

export function ColoredBadge(props: ColoredBadgeProps): React.ReactNode {

    const {
        id,
        className,
        text,
        textColor,
        backgroundColor,
        textVariant = "Desktop & Mobile/Heading/H3",
        ...otherProps
    } = props

    return <Styled.Wrapper
        id={id}
        className={className}
        color={backgroundColor}
        {...otherProps}
    >
        <Styled.Typography
            color={textColor}
            variant={textVariant}
        >
            {text}
        </Styled.Typography>
    </Styled.Wrapper>
}